import { render, staticRenderFns } from "./AppMenuUsuario.vue?vue&type=template&id=08d1ba28&"
import script from "./AppMenuUsuario.vue?vue&type=script&lang=js&"
export * from "./AppMenuUsuario.vue?vue&type=script&lang=js&"
import style0 from "./AppMenuUsuario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports